import 'twin.macro';
import React from 'react';
import { TagPicker } from '@teetsh/app/src/components/Form/TagPicker';
import { Field } from 'react-final-form';
import SimpleInput from '@teetsh/app/src/components/Form/InputGroup/formWrapper';
import { useTranslation } from 'react-i18next';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useColorPalette } from 'containers/App/context/useColorPalette';

interface Props {
  inputRef?: any;
  hideTags?: boolean;
  classroomIds?: string[];
  onAddTagToClassroom: (p: {
    tagId: string;
    classroomId: string;
  }) => Promise<any>;
  setTitleIfEmpty?: (oldTag?: string) => void;
}

export function ModalHeader(props: Props) {
  const {
    hideTags,
    inputRef,
    classroomIds,
    onAddTagToClassroom,
    setTitleIfEmpty,
  } = props;
  const { guestMode } = useUser();
  const { colorPalette } = useColorPalette();
  const { t } = useTranslation(['common', 'cahierJournal']);

  return (
    <div tw="flex justify-between w-full items-center">
      <div tw="mb-0 flex-grow font-normal min-w-[13rem]">
        <Field
          withoutMargin
          name="title"
          data-testid="event-title"
          placeholder={t('cahierJournal:seance.modal.titlePlaceholder')}
          className="modal-title-input"
          autoFocus
          inputRef={inputRef}
          component={SimpleInput}
        />
      </div>
      {!hideTags && (
        <div tw="ml-2 shrink truncate">
          <Field
            name="tag"
            render={({ input: { value, onChange } }) => (
              <TagPicker
                onAddTagToClassroom={onAddTagToClassroom}
                classroomIds={classroomIds}
                disableEdit={guestMode?.enabled}
                value={value?.id}
                onChange={v => {
                  // C'est pour éviter d'avoir le champ tag dirty au mount
                  if (JSON.stringify(v) !== JSON.stringify(value)) {
                    onChange(v);
                    // C'est pour éviter l'absence accidentelle de titre au print
                    setTitleIfEmpty?.(value?.title);
                  }
                }}
                colorPalette={colorPalette}
              />
            )}
          />
        </div>
      )}
    </div>
  );
}
